import React from 'react';
// Inlined header to avoid module-resolution issues with Header component
import Footer from '../components/Footer';
import FAQItem from '../components/FAQItem';
import { FiFlag, FiHeart, FiLink, FiMessageCircle, FiSearch, FiShare2, FiUser, FiUsers } from 'react-icons/fi';
import Header from '../components/Header';
import SEO from '../components/SEO';

const faqItems = [
  {
    title: 'Why do I have a learnaicare.com charge on my bank statement?',
    content:
      'If a direct debit appears on your statement, you have probably signed up to a subscription to one of our partner sites for which we provide the after-sales service. Please note that you are not a client of learnaicare.com, but a client of a site that has delegated the management of its customer service.',
    icon: <FiHeart />,
  },
  {
    title: 'What are the services offered by learnaicare.com?',
    content:
      'learnaicare.com offers simplified management of your subscription. Fill in the form on the home page with an e-mail address used at the time of subscription. You will be able to contact the agents responsible for your file, obtain all the information concerning your subscription or cancel it.',
    icon: <FiFlag />,
  },
  {
    title: 'What kind of subscription do you need for after-sales service?',
    content:
      'learnaicare.com provides customer service subscriptions that make your life easier. We work with sites that offer help to individuals or professionals, accompanying the client during various operations or steps.',
    icon: <FiSearch />,
  },
  {
    title: 'I do not remember signing up to a learnaicare.com subscription.',
    content:
      'You have not signed up to a learnaicare.com subscription. You have definitely signed up to a subscription at one of our partner sites for which we provide after-sales service.',
    icon: <FiShare2 />,
  },
  {
    title: 'How to find the offer to which I subscribed?',
    content:
      'Fill in the form on the home page with the email address used when registering. We will provide you with important information about your subscription, such as the date and amount of the next withdrawal and the service features you have selected.',
    icon: <FiLink />,
  },
  {
    title: 'I forgot the email address used when subscribing. What can I do?',
    content:
      'If you are unable to retrieve the email address used during the subscription, our agents always have the possibility to find your client file. Contact our agents by email or chat.',
    icon: <FiUser />,
  },
  {
    title: 'Who can I contact if I have a question?',
    content:
      'Our agents are experts in after-sales service and are available 24/7. Contact them by live chat or by phone via our toll-free number any time you need. You can also send them a message.',
    icon: <FiMessageCircle />,
  },
  {
    title: 'How can I cancel my subscription?',
    content:
      'Go to your customer account and click the Cancel button. You will no longer benefit from the services of our partner site and will no longer be charged. A confirmation email will be sent.',
    icon: <FiUsers />,
  },
];

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  name: 'Frequently Asked Questions | Learnaicare',
  url: 'https://lsabill.net/faqs',
  mainEntity: faqItems.map((item) => ({
    '@type': 'Question',
    name: item.title,
    acceptedAnswer: {
      '@type': 'Answer',
      text: item.content,
    },
  })),
};

export default function FAQPage() {
  return (
    <div className="page-shell min-h-screen">
      <SEO
        title="Frequently Asked Questions | Learnaicare"
        description="Find answers to common questions about subscriptions, billing charges, cancellations, account access, and customer support services."
        canonical="https://lsabill.net/faqs"
        ogUrl="https://lsabill.net/faqs"
        schema={faqSchema}
      />
      <Header />
     

      <section className="relative w-full overflow-hidden mt-0">

        <div className="relative w-full px-0 py-0">
          <div className="w-full mx-auto max-w-full rounded-[1rem] border-t border-white/60 bg-white/90 py-8 sm:py-10 shadow-[0_12px_36px_-20px_rgba(7,26,49,0.12)] backdrop-blur-sm">
            <div className="max-w-4xl mx-auto px-6 sm:px-8">
        

            <h1 className="mt-4 text-center text-3xl font-bold leading-tight text-[#2f4f42] sm:text-4xl">
              Frequently asked questions
            </h1>

            <p className="mt-3 text-center text-sm leading-7 text-[#5e675f] max-w-2xl mx-auto">
              Everything you need to understand your subscription management, cancellation process, and support access.
            </p>
          </div>
        </div>
        </div>
      </section>

      <main className="px-4 py-8 sm:px-6 lg:px-8 lg:py-10 mt-2 sm:mt-3 lg:mt-4">
        <div className="mx-auto max-w-4xl px-2 sm:px-0">
          <section>
            <div className="space-y-6">
              {faqItems.map((item) => (
                <FAQItem key={item.title} title={item.title} icon={item.icon}>
                  {item.content}
                </FAQItem>
              ))}
            </div>
          </section>
        </div>
      </main>

      <Footer />
    </div>
  );
}

